module.exports = __webpack_public_path__ + "static/img/meiguihuacha.8ff6abc9.png";